import { createNextTableContext } from '@core/table';

export const CustomsDeclarationsTableContext = createNextTableContext();
